import { registerFlow } from '../../../../core/flow-register';
import { makeFlow } from '../index';
import { IRAAccountTypes } from '../../../transfer-flows/loaders';

registerFlow(
  makeFlow('sep-ira', {
    toIRAAccountType: IRAAccountTypes.TRADITIONAL,
    fromIRAAccountType: IRAAccountTypes.SEP
  })
);
